// extracted by mini-css-extract-plugin
export default {"grayBackgroundItems":"checkModalBody_grayBackgroundItems__k9J7w"};